import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { apiMasterPartnersFetch } from '@/services/DataService';
import { setMasterPartners, setLoading, setError, MasterPartnersState } from '@/store/slices/data/masterPartnersSlice';
import useAuth from './useAuth';
import { useAppSelector } from '@/store';

const useMasterPartnersFetch = () => {
    const dispatch = useDispatch();
    const { authenticated } = useAuth();
    const masterPartnersState = useAppSelector((state) => state.data.masterPartnersState);

    useEffect(() => {
        if (authenticated && masterPartnersState.masterPartners.length === 0) {
            const fetchMasterPartners = async () => {
                dispatch(setLoading(true));
                try {
                    const response = await apiMasterPartnersFetch();
                    dispatch(setMasterPartners(response.data[0]));
                    dispatch(setLoading(false));
                } catch (error: any) {
                    dispatch(setError(error.message));
                    dispatch(setLoading(false));
                }
            };
            fetchMasterPartners();
        }
    }, [dispatch, authenticated, masterPartnersState.masterPartners.length]);

    return masterPartnersState as MasterPartnersState;
};

export default useMasterPartnersFetch;
